import type {
  Organization,
  Room,
  User,
  Glossary,
  Recording,
  DocumentTranslation,
} from "../hooks/api-new";

export const STUB_USER: User = {
  id: "stub-user-1",
  email: "demo@langfinity.ai",
  name: "Demo User",
  created_at: new Date("2026-01-01"),
  org_id: "stub-org-1",
  user_type: "admin",
  languages: ["en-US", "es-MX", "fr-FR"],
};

export const STUB_ORGANIZATION: Organization = {
  id: "stub-org-1",
  name: "Demo Organization",
  owner_id: "stub-user-1",

  translation_seconds_remaining: 36000,
  max_room_participants_allowed: 50,
  recording_enabled: true,
  voice_translation_enabled: true,
  voice_avatar_enabled: true,
  max_languages_allowed: 10,
  max_members_allowed: 20,
  glossary_enabled: true,
  autodetect_enabled: true,
  human_interpreter_enabled: true,

  default_languages_setting: ["en-US", "es-MX", "fr-FR"],
  default_avatar_setting: "default",
  default_ai_voice_setting: true,
  default_recording_setting: false,
  default_qna_setting: false,
  default_text_translation_setting: {
    text_size: 14,
    text_color: "#101010",
    text_background_color: "#fff",
    text_speed: 0,
  },

  created_at: "2026-01-01T00:00:00.000Z",
  training_data_opt_in: false,

  members: [
    {
      id: "stub-user-1",
      name: "Demo User",
      email: "demo@langfinity.ai",
      isOwner: true,
    },
    {
      id: "stub-user-2",
      name: "Jane Smith",
      email: "jane@langfinity.ai",
      isOwner: false,
    },
  ],

  teams_adhoc_enabled: false,
  document_translation_enabled: true,
};

export const STUB_ROOM: Room = {
  id: "stub-room-1",
  languages: ["en-US", "es-MX", "fr-FR"],
  default_voice_on: true,
  room_type: "meeting",
  host_id: "stub-user-1",
  name: "Demo Meeting Room",
  org_id: "stub-org-1",
  created_at: "2026-01-15T10:00:00.000Z",
  meeting_url: null,
  auto_record: false,
  deep_link: null,
  teams_chat_id: null,
  default_voice_avatar: "default",
  num_speakers: 2,
  start_time: null,
  end_time: null,
  translation_domain: null,
  qna: false,
  recording_status: "idle",
  active_recording_id: null,
  reoccurring: false,
  available_24_7: false,
  pin: "123456",
  debug: false,
};

export const STUB_ROOM_2: Room = {
  id: "stub-room-2",
  languages: ["en-US", "zh-CN"],
  default_voice_on: false,
  room_type: "event",
  host_id: "stub-user-1",
  name: "Stub Conference Event",
  org_id: "stub-org-1",
  created_at: "2026-02-10T08:00:00.000Z",
  meeting_url: null,
  auto_record: true,
  deep_link: null,
  teams_chat_id: null,
  default_voice_avatar: "default",
  num_speakers: 1,
  start_time: "2026-03-20T09:00:00.000Z",
  end_time: "2026-03-20T11:00:00.000Z",
  translation_domain: null,
  qna: true,
  recording_status: "idle",
  active_recording_id: null,
  reoccurring: false,
  available_24_7: false,
  pin: "654321",
  debug: false,
};

export const STUB_GLOSSARY: Glossary = {
  id: "stub-glossary-1",
  phrases: ["Langfinity", "LiveKit", "interpretation"],
  org_id: "stub-org-1",
  language: "en-US",
  created_at: "2026-01-01T00:00:00.000Z",
};

export const STUB_RECORDING_AUDIO: Recording = {
  id: "stub-recording-audio",
  languages: ["en-US", "es-MX"],
  created_at: "2026-01-20T10:00:00.000Z",
  room_id: "stub-room-2",
  room_type: "event",
  egress_id: null,
  egress_started_at: null,
  stopped_at: "2026-01-20T11:00:00.000Z",
  summaries: {
    en: "This is a stub summary of the event recording.",
    es: "Este es un resumen de prueba de la grabación del evento.",
  },
  public: false,
  name: "Demo Event Recording (Audio)",
};

export const STUB_RECORDING_VIDEO: Recording = {
  id: "stub-recording-video",
  languages: ["en-US", "es-MX"],
  created_at: "2026-02-15T14:00:00.000Z",
  room_id: "stub-room-1",
  room_type: "meeting",
  egress_id: null,
  egress_started_at: null,
  stopped_at: "2026-02-15T15:00:00.000Z",
  summaries: {
    en: "This is a stub summary of the meeting recording.",
    es: "Este es un resumen de prueba de la grabación de la reunión.",
  },
  public: false,
  name: "Demo Meeting Recording (Video)",
};

export const STUB_DOCUMENT_COMPLETED: DocumentTranslation = {
  id: "stub-doc-1",
  org_id: "stub-org-1",
  uploaded_by: "stub-user-1",
  original_filename: "annual-report.pdf",
  original_s3_key: "document-translations/stub-org-1/stub-doc-1/original.pdf",
  translated_s3_key: "document-translations/stub-org-1/stub-doc-1/translated.pdf",
  source_language: "en-US",
  target_language: "en-US,es-ES",
  status: "completed",
  key_terms: {
    "en-US": ["Revenue", "Shareholders", "Quarterly"],
    "es-ES": ["Ingresos", "Accionistas", "Trimestral"],
  },
  error_message: null,
  progress: 100,
  created_at: "2026-04-10T09:00:00.000Z",
};

export const STUB_DOCUMENT_PROCESSING: DocumentTranslation = {
  id: "stub-doc-2",
  org_id: "stub-org-1",
  uploaded_by: "stub-user-1",
  original_filename: "contract-draft.pdf",
  original_s3_key: "document-translations/stub-org-1/stub-doc-2/original.pdf",
  translated_s3_key: null,
  source_language: null,
  target_language: "en-US,fr-FR",
  status: "processing",
  key_terms: null,
  error_message: null,
  progress: 45,
  created_at: "2026-04-17T08:30:00.000Z",
};

export const STUB_DOCUMENT_FAILED: DocumentTranslation = {
  id: "stub-doc-3",
  org_id: "stub-org-1",
  uploaded_by: "stub-user-1",
  original_filename: "scanned-invoice.pdf",
  original_s3_key: "document-translations/stub-org-1/stub-doc-3/original.pdf",
  translated_s3_key: null,
  source_language: null,
  target_language: "en-US,de-DE",
  status: "failed",
  key_terms: null,
  error_message: "Error processing file",
  progress: 0,
  created_at: "2026-04-16T14:00:00.000Z",
};

export const STUB_LIVEKIT_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJzdHViLXVzZXIiLCJuYW1lIjoiRGVtbyBVc2VyIiwiaWF0IjoxNTE2MjM5MDIyfQ.stub-signature";

export const STUB_AUTH_TOKEN = "stub-langfinity-token";
